import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "../../../components/Pagination";
import "./style.css";
import filter from "../../../images/icons/filter.png";
import editIcon from "../../../images/icons/edit.png";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Modal from "react-bootstrap/Modal";
import viewIcon from "../../../images/view.png";
import BranchViews from "./view";
import BranchAdd from "./Add";
import BranchEdit from "./Edit";
import { apiCancelBranch, apiListBranch } from "../../../api/master";
import { apiCity, apiState } from "../../../api/stateAndCity";
import Swal from "sweetalert2";
import { removeEmptyFields } from "../../../utils";

function BranchList() {
  const initialState = {
    branch_name: "",
    is_active: "",
  };

  const [stateValue, setStateValue] = useState([]);
  const [city, setCity] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showId, setShowId] = useState(0);
  const [editId, setEditId] = useState("");

  const [formInputs, setFormInputs] = useState(initialState);
  const [filtersVisible, setFiltersVisible] = useState(false);

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);

  async function changeStatus(branch_id, status) {
    let target = window.event.target;
    let oldText = target.innerText;
    target.innerText = "Updating...";
    await apiCancelBranch({ branch_id: branch_id, is_active: status })
      .then((data) => {
        setError("");
      })
      .catch((err) => {
        setError(err.response.data.data.message);
        setTimeout(function () {
          setError("");
        }, 3000);
      })
      .finally(() => {
        target.innerText = oldText;
        getList(filtersVisible);
      });
  }

  async function getList(isFilter = true, pageNo = null) {
    let json = { paginate: 1, page_no: (pageNo || currentPage) - 1 };
    if (isFilter) {
      json = { ...json, ...formInputs };
    }

    json = removeEmptyFields(json);

    await apiListBranch(json)
      .then((data) => {
        setCurrentPage(pageNo || currentPage);
        setIsSubmit(false);
        setList(data.data.data.list);
        setIsLoading(false);
        setTotalPage(data.data.data.count);
      })
      .catch(function (err) {
        setIsSubmit(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response.data.data.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      });

    await apiState().then((result) => setStateValue(result.data.data.list));
    await apiCity().then((result) => setCity(result?.data?.data.list));
  }

  useEffect(
    function () {
      getList(filtersVisible);
    },
    [currentPage]
  );

  function handleInputs(e) {
    setFormInputs({ ...formInputs, [e.target.id]: e.target.value });
  }

  function handleFilterVisibility() {
    if (filtersVisible) {
      setFiltersVisible(false);
      setFormInputs(initialState);
    } else {
      setFiltersVisible(true);
    }
  }

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />
          <main className="bg-white rounded-2" id="buyer">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col">
                  <Breadcrumb path={["Branch"]} />
                </div>
                <div
                  className="col text-end"
                  style={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "end",
                  }}
                >
                  <Tippy content="Filter">
                    <img
                      onClick={() => handleFilterVisibility()}
                      src={filter}
                      className="img-fluid me-3"
                      alt=""
                      role="button"
                      style={{ width: "2rem" }}
                    />
                  </Tippy>

                  <Link
                    onClick={(v) => {
                      handleShow();
                      setShowId(1);
                    }}
                    className="btn btn-primary px-4 py-2"
                    style={{
                      height: "33px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Add Branch
                  </Link>
                </div>
              </div>

              {filtersVisible && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setIsSubmit(true);
                    currentPage > 1 ? setCurrentPage(1) : getList(true, 1);
                  }}
                  autoComplete="off"
                >
                  <div className="row" id="buyerAdd">
                    <div className="col">
                      <label htmlFor="branch_name">Branch Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="branch_name"
                        value={formInputs.branch_name}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="default_godown">Status</label>
                      <select
                        className="form-select"
                        value={formInputs.is_active}
                        onChange={handleInputs}
                        id="is_active"
                      >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="0">In-Active</option>
                      </select>
                    </div>
                    <div
                      className="col-md-4 mt-auto"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "end",
                        float: "right",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        style={{
                          height: "33px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          float: "right",
                        }}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Search
                      </button>
                      <button
                        className="btn btn-primary rounded-3 px-3 ms-2"
                        type="button"
                        onClick={(e) => {
                          setFormInputs(initialState);
                          currentPage > 1
                            ? setCurrentPage(1)
                            : getList(false, 1);
                        }}
                        // style={{ background: "#4263eb", fontSize: "14px" }}
                        style={{
                          height: "33px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          float: "right",
                          background: "#4263eb",
                          fontSize: "14px",
                        }}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </div>
                </form>
              )}

              {error && (
                <div className="row mt-3">
                  <div className="col">
                    <div
                      className={`alert alert-danger py-1 small`}
                      role="alert"
                    >
                      {error || ""}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                <div className="col">
                  <table className={`table ${error ? "my-1" : "mt-4"} rounded`}>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Branch Name</th>
                        <th>Branch Address</th>
                        {/* <th>State</th>
                        <th>City</th>
                        <th>Pincode</th> */}
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading || list.length == 0) && (
                        <tr>
                          <td colSpan="9" className="text-center">
                            {isLoading ? "Loading..." : "No Records"}
                          </td>
                        </tr>
                      )}
                      {list.map((v, i) => (
                        <tr key={`bl_` + i}>
                          <td>{currentPage * 10 - 10 + i + 1}</td>
                          <td>{v.branch_name}</td>
                          <td>
                            {" "}
                            {v?.branch_address?.length > 15
                              ? v?.branch_address?.substring(0, 15) + "..."
                              : v?.branch_address}
                          </td>
                          {/* <td>{v?.branch_address?.substring(0, 20) + "..."}</td> */}
                          {/* <td>
                            {
                              stateValue?.find(
                                (el) => el?.state_id === v?.state_id
                              )?.name
                            }
                          </td>
                          <td>
                            {
                              city?.find((el) => el?.city_id === v.city_id)
                                ?.city
                            }
                          </td>
                          <td>{v.pincode}</td> */}
                          <td>
                            <Tippy content="Change Status">
                              {v.is_active ? (
                                <span
                                  className="badge text-bg-success"
                                  role="button"
                                  onClick={() => changeStatus(v.branch_id, 0)}
                                >
                                  Active
                                </span>
                              ) : (
                                <span
                                  className="badge text-bg-danger"
                                  role="button"
                                  onClick={() => changeStatus(v.branch_id, 1)}
                                >
                                  In-Active
                                </span>
                              )}
                            </Tippy>
                          </td>
                          <td>
                            <Tippy content="View" trigger="mouseenter">
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setEditId(v);
                                  handleShow();
                                  setShowId(3);
                                }}
                              >
                                <img
                                  src={viewIcon}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                              </a>
                            </Tippy>

                            <Tippy content="Edit" trigger="mouseenter">
                              <Link
                                onClick={() => {
                                  setEditId(v);
                                  handleShow();
                                  setShowId(2);
                                }}
                                className={`link-info ${
                                  v.is_active ? "" : "d-none"
                                }`}
                              >
                                <img
                                  src={editIcon}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                              </Link>
                            </Tippy>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / 10)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
              <Modal
                show={show}
                onHide={handleClose}
                keyboard={false}
                backdrop="static"
              >
                {showId == 1 ? (
                  <BranchAdd id={editId} list={getList} hide={handleClose} />
                ) : showId == 2 ? (
                  <BranchEdit id={editId} list={getList} hide={handleClose} />
                ) : showId == 3 ? (
                  <BranchViews id={editId} list={getList} hide={handleClose} />
                ) : null}
              </Modal>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default BranchList;
